import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferPRApprovalService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  invitePRUser = async ({
    offerId,
    costBudgetIndex,
    vendorSelectionIndex,
    submissionIndex,
    approverIndex,
    ...data
  }) => {
    const response = await axios.post(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/approvers/${approverIndex}/invitee`,
      data
    )
    return response.data
  }

  replyPRInvitation = async ({
    offerId,
    costBudgetIndex,
    vendorSelectionIndex,
    submissionIndex,
    approverIndex,
    inviteeIndex,
    ...data
  }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/approvers/${approverIndex}/invitee/${inviteeIndex}/reply`,
      {
        ...data,
        approverIndex: approverIndex,
      }
    )
    return response.data
  }

  deletePRInvitedUsers = async ({
    offerId,
    costBudgetIndex,
    vendorSelectionIndex,
    submissionIndex,
    approverIndex,
    ...data
  }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/costBudgets/${costBudgetIndex}/PR/vendorSelections/${vendorSelectionIndex}/submissions/${submissionIndex}/approvers/${approverIndex}/invitee/delete`,
      data
    )
    return response.data
  }
}

export default OfferPRApprovalService
